export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/ob-step-16.png?4c3023f2059d4abcfb65afe5a1d1ad52";